import { MenuItemProps, ResolvedBasicMenuItem, ResolvedSubMenuItem } from '@wix/thunderbolt-becky-types'

export const resolveMenuItemsRecursively = (
	item: ResolvedBasicMenuItem | ResolvedSubMenuItem,
	isMobileView: boolean,
	withId: boolean
): MenuItemProps => {
	const id = withId ? { id: item.id } : {}
	const label = item.label
	const subItems = item.items
	// @ts-ignore
	const link = item.link?.resolvedLink ?? {}
	const slot = isResolvedBasicMenuItem(item) ? { slot: item.slot } : {}

	const items = subItems
		? subItems
				.filter((subItem) => shouldShowItem(subItem, isMobileView))
				.map((subItem) => resolveMenuItemsRecursively(subItem, isMobileView, withId))
		: []

	const filteredItems = items.length > 0 ? { items } : {}

	const result: MenuItemProps & { slot?: string } = {
		label,
		link,
		...filteredItems,
		...slot,
		...id,
	}

	return result
}

const isResolvedBasicMenuItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem): item is ResolvedBasicMenuItem =>
	'slot' in item

const shouldShowItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem, isMobileView: boolean) => {
	const isVisible = isMobileView ? item.isVisibleMobile : item.isVisible
	const noSlot = !isResolvedBasicMenuItem(item) || !item.slot
	return isVisible && noSlot
}
